import { apiGet } from "../shared";
import { validateIngredientIds } from "@/lib/utils/ingredientValidation";
import { sortByPriorityOrder } from "@/lib/utils/arrayTransforms";
import type { IngredientAlternative } from "@/lib/types/alternatives";
import { GENERIC_INGREDIENT_ENDPOINTS } from "./endpoints";
import type {
  BackendGenericIngredientResponse,
  GetGenericIngredientsByIdsResponse,
} from "./types";

function transformGenericIngredient(
  backendIngredient: BackendGenericIngredientResponse,
): IngredientAlternative {
  return {
    id: backendIngredient.id,
    name: backendIngredient.name,
    displayName: backendIngredient.display_name || backendIngredient.name,
    unitPrice: null,
    thumbnail: null,
    categoryPath: backendIngredient.category_path,
  };
}

export async function getGenericIngredientsByIds(ids: number[]): Promise<IngredientAlternative[]> {
  if (!ids || ids.length === 0) {
    return [];
  }

  validateIngredientIds(ids);

  const url = GENERIC_INGREDIENT_ENDPOINTS.GET_BY_IDS(ids);
  const response = await apiGet<GetGenericIngredientsByIdsResponse>(url);

  if (!response.data || response.data.length === 0) {
    return [];
  }

  const sortedIngredients = sortByPriorityOrder(response.data, ids);
  return sortedIngredients.map(transformGenericIngredient);
}

export default getGenericIngredientsByIds;
